const obj = {
  id: '',
  company: '',
  date: '',
  email: '',
  eventId: '',
  eventName: '',
  guestCompany: '',
  guestEmail: '',
  guestId: '',
  guestName: '',
  guestPhone: '',
  guestPosition: '',
  name: '',
  note: '',
  organization: '',
  organizationId: '',
  phone: '',
  position: '',
  scheduleName: '',
  stars: 0,
  userEmail: '',
  userName: ''
}

export default function GuestReportModel(params = obj) {
  return { ...obj, ...params, };
};
